import { useMutation } from '@tanstack/react-query';
import { loginUser, registerUser, sendVerificationCode, LoginCredentials, RegisterData } from '../services/api';
import { queryClient } from '../services/queryClient';
import { useNavigate } from 'react-router-dom';

export const useLogin = () => {
  const navigate = useNavigate();
  
  return useMutation({
    mutationFn: (credentials: LoginCredentials) => loginUser(credentials),
    onSuccess: (token) => {
      // Store the token in localStorage
      localStorage.setItem('accessToken', token);
      
      // Redirect to dashboard
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
    },
  });
};

export const useRegister = () => {
  return useMutation({
    mutationFn: (data: RegisterData) => registerUser(data),
    onSuccess: () => {
      // Invalidate and refetch any queries that might be affected
      queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
};

export const useSendVerificationCode = () => {
  return useMutation({
    mutationFn: (email: string) => sendVerificationCode(email),
  });
};
